import React, { useState, useEffect } from "react";
import { storage } from "../Config/firebase";
import { ref, uploadBytes, listAll, getDownloadURL } from "firebase/storage";
import { v4 } from "uuid";
import { useDispatch } from "react-redux";
import { bannerImage,wallDecorate } from "../Redux/Slice/bannerSlice";
import { useSelector } from "react-redux";
import { getDocs,collection } from "firebase/firestore";
import { db } from "../Config/firebase";

const UploadImg = () => {
  const dispatch = useDispatch();
  const wallDecorsData=collection(db,'walldecor')//to tell the app to get the data from this collection

  const [image, setImage] = useState(null);
  const [wallDecor,setWallDecor]=useState(null);

  const [imageList, setImageList] = useState([]);
  const [wallDecoreList, setWallDecoreList] = useState([]);

  const getImages = ref(storage, "corosel/");
  const wallDeco = ref(storage, "walldecor/");
  const images = useSelector((state) => state.banner);

  useEffect(() => {
    const fetchImages = async () => {
      const response = await listAll(getImages);
      const urls = await Promise.all(
        response.items.map((item) => getDownloadURL(item))
      );
      setImageList(urls);
      if (imageList) {
        dispatch(bannerImage(imageList));
      }
      // dispatch(bannerImage(imageList))
      // console.log(images);
    };

    const fetchWallDecorImages = async () => {
      const response = await listAll(wallDeco);
      const urls = await Promise.all(
        response.items.map((item) => getDownloadURL(item))
      );
      setWallDecoreList(urls);
      console.log(wallDecoreList);
      // if (imageList) {
      //   dispatch(bannerImage(imageList));
      // }
      // dispatch(bannerImage(imageList))
      // console.log(images);
    };

    fetchImages();
    fetchWallDecorImages()
    getWallDecorData()
  }, [imageList,wallDecoreList]);


  const uploadImage = () => {
    if (image == null) return;
    const imageRef = ref(storage, `corosel/${image.name + v4()}`);
    uploadBytes(imageRef, image).then(() => {
      console.log("uploaded");
      alert("Image Uploaded");
    });
  };

  const getWallDecorData=async()=>{
    const data= await getDocs(wallDecorsData)
    const wallItems= data?.docs?.map((doc)=>( 
      {...doc.data(),
          id:doc.id
      }
   ))
   wallItems?.forEach((item,index)=>{
    if(index<wallDecoreList.length){
      item.image=wallDecoreList[index]
    }else {
      console.log('Not enough images for all users');
      item.image = 'default-image.jpg'; // Fallback if not enough images
  }
    console.log('wallItem',wallItems);

   })

   dispatch(wallDecorate(wallItems));
  }


  const uploadWallDecor=()=>{
    if(wallDecor==null) return;
    const wallcDecorRef=ref(storage,`walldecor/${wallDecor.name+v4()}`);
    uploadBytes(wallcDecorRef,wallDecor).then(()=>{
      alert('wall decore uploaded')
    })
  }

  return (
    <div>
      <input
        type="file"
        onChange={(event) => {
          setImage(event.target.files[0]);
        }}
      />
      <button onClick={uploadImage}>Upload Image</button>
      <br />
      {imageList?.map((url, id) => (
        <img key={id} src={url} style={{ width: "200px" }} />
      ))}
<br/>

<input
        type="file"
        onChange={(event) => {
          setWallDecor(event.target.files[0]);
        }}
      />
      <button onClick={uploadWallDecor}>Upload Image</button>
      <br />
      {wallDecoreList?.map((url, id) => (
        <img key={id} src={url} style={{ width: "200px" }} />
      ))}
    </div>
  );
};


export default UploadImg;
